<script>
import { mapState, mapActions } from 'pinia'

import defaultAppInit from '@toni/rendering/src/mixins/default-app-init.js'
import { usePageStore } from '@toni/rendering/src/stores/page'
import { IntouchLogo } from '@toni/brand-ui'

import AppLayout from '../../components/app-layout/AppLayout.vue'
import AppContent from '../../components/app-layout/AppContent.vue'
import AppHeader from '../../components/app-layout/AppHeader.vue'
import AppFooter from '../../components/app-layout/AppFooter.vue'
import TrendingMenu from '../../components/ui/additional-menu/TrendingMenu.vue'
import BlockArticleHeader from './components/page-blocks/article-header/BlockArticleHeader.vue'

export default {
  name: 'App',
  components: {
    IntouchLogo,
    AppLayout,
    AppHeader,
    AppContent,
    AppFooter,
    TrendingMenu,
    BlockArticleHeader
  },
  mixins: [defaultAppInit],
  data () {
    return {
      footerData: {
        badge: 'inTouch Newsletter',
        newsletter: {
          headline: 'Noch mehr Star-News',
          text: 'Abonniere unseren Newsletter und wir versorgen dich täglich mit den wichtigsten Promi-News zu deinen Lieblingsstars',
          button: 'Newsletter abonnieren'
        },
        content: {
          title: 'inTouch - Dein Promi-Magazin mit den heißesten News zu deutschen Promis und internationalen Stars.'
        },
        magazine: {
          cover: 'https://cdn.bauerdcs.io/cover/intouch.jpg',
          coverAlt: 'inTouch Magazin',
          description: 'inTouch ist das wöchentliche People-Magazin, das ganz dicht an den Stars dran ist.',
          button: 'Abo abschließen'
        }
      }
    }
  },
  computed: {
    ...mapState(usePageStore, ['pageData', 'brandFromStore', 'isHome']),
    isHomeComputed () {
      return this.pageData.pageMeta.url === '/'
    }
  },
  mounted () {
    this.setIsHome(this.isHomeComputed)
  },
  methods: {
    ...mapActions(usePageStore, ['setIsHome'])
  }
}
</script>

<template>
  <AppLayout :meta-data="pageData.metaData"
             :page-meta="pageData.pageMeta">
    <AppHeader>
      <IntouchLogo class="h-9" />
    </AppHeader>
    <TrendingMenu v-if="pageData.header?.additionalMenu?.length"
                  :items="pageData.header.additionalMenu" />
    <AppContent v-if="pageData?.body"
                :page-data="pageData.body"
                :page-meta="pageData.pageMeta"
                :meta-data="pageData.metaData"
                :brand="brandFromStore">
      <template #article-header>
        <BlockArticleHeader
          v-if="pageData.pageMeta.pageType === 'article'"
          :body="pageData.body"
          :meta-data="pageData.metaData"
          :brand="brandFromStore" />
      </template>
    </AppContent>
    <AppFooter v-if="pageData?.footer"
               :value="pageData.footer"
               :footer-data="footerData"
               :page-data="pageData.body"
               :is-home="isHome">
      <IntouchLogo class="h-9" />
    </AppFooter>
  </AppLayout>
</template>
